import { createAction } from '@reduxjs/toolkit';

export const CALL_STACK_BACK_ACTION_TYPE = 'saga/callStackBack';
export const callStackBackAction = createAction(CALL_STACK_BACK_ACTION_TYPE);
